module.exports = {
	"Search the video": "Video doorzoeken",
	"Explore": "Verkennen",
	"Print": "Afdrukken",
	"Download": "Downloaden",
	"Share": "Delen",
	"Settings": "Instellingen",
	"Language": "Taal",
	"Interface Language": "Interfacetaal",
	"Transcript / Captions Language": "Taal van transcriptie/opschriften",
	"Transcript Language": "Taal van transcriptie",
	"Captions Language": "Taal van opschriften",
	"Show Transcript": "Transcriptie tonen",
	"Show Captions": "Opschriften tonen",
	"Show Heatmap": "Warmtekaart tonen",
	"Show Speakers in Transcript": "Sprekers in transcriptie tonen",
	"Keyword": "Trefwoord",
	"Keywords": "Trefwoorden",
	"Topic": "Onderwerp",
	"Topics": "Onderwerpen",
	"Speaker": "Spreker",
	"Speakers": "Sprekers",
	"Transcript": "Transcriptie",
	"Previous": "Vorige",
	"Next": "Volgende",
	"Clear": "Wissen",
	"No results found": "Geen resultaten gevonden",
	"try another search or explore": "probeer een andere zoekactie of verken",
	"Share Search": "Zoekopdracht en meerdere resultaten delen",
	"Share Time": "Videotijd delen",
	"There is no transcript available in the selected language.": "Er is geen transciptie in deze taal beschikbaar.",
	"Show {{count}} more": "Toon {{count}} resultaat extra",
	"Show {{count}} more_plural": "Toon {{count}} resultaten extra"
};


//////////////////
// WEBPACK FOOTER
// ./locale/nl.json
// module id = ./locale/nl.json
// module chunks = 0 1